module.exports = __webpack_public_path__ + "img/logo-white.e7cc8405.svg";